var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    { staticStyle: { height: "calc(100vh - 273px)" } },
    [
      _c("el-aside", { attrs: { width: _vm.asideWidth } }, [
        _c(
          "div",
          { staticClass: "components" },
          _vm._l(_vm.baseComponents, function (group, i) {
            return _c("div", { key: i }, [
              _c("p", { staticClass: "group-name" }, [
                _vm._v(_vm._s(group.name)),
              ]),
              _c(
                "ul",
                [
                  _c(
                    "draggable",
                    {
                      staticClass: "drag",
                      attrs: {
                        list: group.components,
                        options: { sort: false },
                        group: { name: "form", pull: "clone", put: false },
                        clone: _vm.clone,
                      },
                      on: {
                        start: function ($event) {
                          _vm.isStart = true
                        },
                        end: function ($event) {
                          _vm.isStart = false
                        },
                      },
                    },
                    _vm._l(group.components, function (cp, id) {
                      return _c("li", { key: id }, [
                        _c("i", { class: cp.icon }),
                        _c("span", [_vm._v(_vm._s(cp.title))]),
                      ])
                    }),
                    0
                  ),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
      _c("el-main", { staticClass: "layout-main" }, [
        _c("div", { staticClass: "work-form" }, [
          _c(
            "div",
            { class: { mobile: _vm.showMobile, pc: !_vm.showMobile } },
            [
              _c("div", { class: { bd: _vm.showMobile } }, [
                _c("div", { class: { "form-content": _vm.showMobile } }, [
                  _c(
                    "div",
                    { staticClass: "form" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.forms.length === 0 && !_vm.isStart,
                              expression: "forms.length === 0 && !isStart",
                            },
                          ],
                          staticClass: "tip",
                        },
                        [_vm._v("拖拽左侧控件至此")]
                      ),
                      _c(
                        "draggable",
                        {
                          staticClass: "drag-from",
                          attrs: {
                            list: _vm.forms,
                            group: "form",
                            options: {
                              animation: 300,
                              chosenClass: "choose",
                              sort: true,
                            },
                          },
                          on: {
                            start: _vm.startDrag,
                            end: _vm.endDrag,
                            change: _vm.dragItem,
                          },
                        },
                        _vm._l(_vm.forms, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "form-item",
                              style: _vm.getSelectedClass(item),
                              on: {
                                click: function ($event) {
                                  return _vm.selectItem(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-header" },
                                [
                                  _c("p", [
                                    item.props.required
                                      ? _c("span", [_vm._v("*")])
                                      : _vm._e(),
                                    _vm._v(_vm._s(item.title) + " "),
                                  ]),
                                  _c("div", { staticClass: "option" }, [
                                    item.name !== "JoinDate"
                                      ? _c("div", {
                                          staticClass: "icon-copy",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.copy(item, index)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _c("div", {
                                      staticClass: "icon-close",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.del(index)
                                        },
                                      },
                                    }),
                                  ]),
                                  _c("form-design-render", {
                                    attrs: { config: item },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _c(
        "el-aside",
        { staticClass: "layout-param", attrs: { width: _vm.asideWidth } },
        [
          _vm.selectFormItem
            ? _c("div", { staticClass: "tool-nav-r" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.formItemTitle(_vm.selectFormItem.icon)) +
                      "配置区"
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.selectFormItem || _vm.forms.length === 0
            ? _c("div", { staticClass: "tip" })
            : _c(
                "div",
                { staticClass: "form-config" },
                [_c("form-component-config")],
                1
              ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            clickClose: "",
            closeFree: "",
            width: "800px",
            showFooter: false,
            border: false,
            title: "表单预览",
          },
          model: {
            value: _vm.viewFormVisible,
            callback: function ($$v) {
              _vm.viewFormVisible = $$v
            },
            expression: "viewFormVisible",
          },
        },
        [
          _c("form-render", {
            ref: "form",
            attrs: { forms: _vm.forms },
            model: {
              value: _vm.formData,
              callback: function ($$v) {
                _vm.formData = $$v
              },
              expression: "formData",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }